const MONTHS = [
  {
    value: "1",
    label: "January"
  },
  {
    value: "2",
    label: "February"
  },
  {
    value: "3",
    label: "March"
  },
  {
    value: "4",
    label: "April"
  },
  {
    value: "5",
    label: "May"
  },
  {
    value: "6",
    label: "June"
  },
  {
    value: "7",
    label: "July"
  },
  {
    value: "8",
    label: "August"
  },
  {
    value: "9",
    label: "September"
  },
  {
    value: "10",
    label: "October"
  },
  {
    value: "11",
    label: "November"
  },
  {
    value: "12",
    label: "December"
  }
];

const FIELDDATATYPES = [
  {
    value: "0",
    label: "String"
  },
  {
    value: "1",
    label: "Date"
  },
  {
    value: "2",
    label: "Country"
  },
  {
    value: "3",
    label: "Nationality"
  },
  {
    value: "4",
    label: "Document"
  },
  {
    value: "5",
    label: "IDDocument"
  },
  {
    value: "6",
    label: "Choice"
  },
  {
    value: "7",
    label: "MultiCountry"
  },
  {
    value: "8",
    label: "Boolean"
  },
  {
    value: "9",
    label: "MultiChoice"
  },
  {
    value: "10",
    label: "Integer"
  }
];

export {
  MONTHS,
  FIELDDATATYPES
};